import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  TextField,
  ListItemText,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DeleteIcon from "@mui/icons-material/Delete";

export default function ProviderSelector({
  providers,
  provider,
  handleChange,
  onDelete,
}) {
  return (
    <Grid container>
      <Grid size={{ xs: 12 }} style={{ display: "flex", alignItems: "flex-end" }}>
        <FormControl style={{ marginRight: 20 }}>
          <FormHelperText>Provider</FormHelperText>
          <Select
            name="provider"
            id="provider"
            value={provider.id}
            onChange={handleChange}
            style={{ minWidth: 270 }}
          >
            {providers.map((Provider) => (
              <MenuItem value={Provider.id} key={Provider.id}>
                {/* <ListItemAvatar>
                  <Avatar alt="Logo" src={Provider.url} />
                </ListItemAvatar> */}
                <ListItemText primary={Provider.name}></ListItemText>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl>
          <TextField
            id="order_url"
            name="order_url"
            type="text"
            label="Order URL"
            onChange={handleChange}
            value={provider.order_url}
          />
        </FormControl>
        <FormControl style={{ marginLeft: 20 }}>
          <DeleteIcon onClick={onDelete} />
        </FormControl>
      </Grid>
    </Grid>
  );
}
